import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { INVOICE_TYPE } from '../constants/invoice.enums';

class InvoiceService extends EntityApiService<any> {
  downloadInvoice = async (type: INVOICE_TYPE, code: string): Promise<Blob> => {
    const config: RequestConfig = {
      responseType: 'blob',
    };
    const response = await ApiClientService.get(this.getPath(`/business/pdf/invoice/${type}/${code}`), config);
    return response.data;
  };
}

export default new InvoiceService('/ms-export/api');
